// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'copyDialogComponent',
    templateUrl: './copy-dialog.component.html',
    standalone: false,
})
export class CopyDialogComponent implements OnInit {
    @Input() resolve!: { copyString: string; headline?: string };
    @Input() close!: () => void;

    headline!: string;

    constructor (private translateService: TranslateService) {}

    ngOnInit (): void {
        this.headline = this.resolve.headline || this.translateService.getString('Copy');
    }
}
